import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function BrandHelmet() {
  const title = import.meta.env.VITE_BRAND_NAME || 'RAF';
  // Always use build-time brand icon for tab favicon to avoid overriding with S3 header images
  const iconBase = import.meta.env.VITE_BRAND_LOGO_PATH || '/brand/app-icon.svg';
  const version = import.meta.env.VITE_ASSET_VERSION ? `?v=${import.meta.env.VITE_ASSET_VERSION}` : '';
  const icon = `${iconBase}${version}`;

  return (
    <Helmet>
      <title>{title}</title>
      <link rel="icon" href={icon} />
      <link rel="apple-touch-icon" href={icon} />
    </Helmet>
  );
}


